export default {
  //我的
  'user.login.register': '登錄 / 註冊',
  'user.item1': '幫助中心',
  'user.item2': '通用設置',
  'user.item3': '安全設置',
  'user.item4': '關於我們',
  'user.item5': '聯系我們',
  'user.logout': '退出登錄',
  'user.index.mine': '我的',
  'user.index.assets': '資產',

  //關於我們
  'footer.contact.item1': '客服微信：',
  'footer.contact.item2': '商務合作：',
  'user.aboutUs.title': '關於我們',
  'user.aboutUs.desc1': 'WBroker成立於2017年，所屬公司是在新西蘭登記註冊的金融服務提供商，持有澳大利亞ASIC經紀牌照、新西蘭FSPR經紀牌照等，致力於為全球客戶提供股票、融資等投資服務。',
  'user.aboutUs.desc2': 'WBroker始終將客戶的資金安全、投資風險視為首要責任，將「簡單•安全」做到極致，為用戶提供最安全可靠、簡單易用的金融服務。',
  'user.aboutUs.desc3': 'WBroker始終關註各層次人群的需求，支持男女平等、關註貧困地區兒童和女性弱勢群體，並一直在為創造一個「所有弱勢群體均有機會參與及分享金融紅利」的夢想而努力。',

  //錯誤嗎
  'error.999991': '參數錯誤',
  'user.tryAgainLater': '請稍後再試',
  'user.accountExist': '賬號已經存在',
  'user.codeError': '驗證碼不匹配',
  'user.amountMoreRate': '出金金額要求大於手續費',
  'user.assetNotEnough': '資金不足',
  'user.code039992': '當前存在申購單,不可提現',
  'user.code039993': '存在未扣款的提現,請稍後',
  'user.code039994': '資產獲取失敗',
  'user.code019111': '人像面不清晰，請重新上傳',
  'user.code019112': '國徽面不清晰，請重新上傳',
  'user.code019115': '圖片模糊，請手動填寫信息',
  'user.code019116': '圖片不匹配',
  'user.code170001': '此信托當前不允許申購',
  'user.code170002': '申購金額小於最低申購標準',
  'user.code170004': '此信托當前不允許贖回',
  'user.code170005': '持倉不足',
  'user.code170006': '存在可申購新股，不可申購和贖回',
  'user.code199921': '您已加入委托計劃，暫不能做此操作',
  'user.code019991': '驗證碼錯誤',
  'user.code019992': '驗證碼不匹配',
  'user.code009995': '該郵箱已經被綁定',
  'user.code009991': '賬號不存在',
  'user.code009992': '密碼錯誤',
  'user.code009993': '賬號重復',
  'user.code019990': '短訊發送錯誤',
  'user.code029992': '對手訂單已被搶購',
  'user.code009997': '姓名身份證不匹配',
  'user.code009998': '身份證已被其他賬號綁定',
  'user.code019999': '此賬號已開戶',
  'user.code020002': '您的年齡暫不能在平臺開戶',
  'user.code020003': '身份證校驗失敗,請聯系客服',
  'user.code019119': '身份證已過有效期',
  'user.code019120': '證件已過有效期',
  'user.code020011': '填寫信息與圖片中信息不一致',
  'user.code009980': '暫不支持此域名郵箱，請更換',
  'user.code019130': '您的賬號異常，已被封號',
  'user.code010002': '存在未完成的借貸',
  'user.code010001': '借貸異常,請聯系客服',
  'user.code039777': '駁回次數超過當日限製',
  'user.code023010': '扣款失敗',
  'user.code577220398': '該新股總融資金額已超出公司融資額度',
  'message.error.199678': '已超過綁定期限',
  'message.error.199668': '邀請碼有誤',
  'message.error.199679': '邀請碼已存在',
  'message.error.199669': '不可填寫註冊時間晚於自己的用戶邀請碼',
  'setting.email.error': '郵箱參數異常',
  'setting.email.code.error': '當前綁定郵箱驗證碼錯誤',
  'setting.new.email.error': '新郵箱驗證碼錯誤',
  'setting.mobile.error': '手機參數異常',
  'setting.mobile.code.error': '當前綁定手機驗證碼驗證錯誤',
  'setting.new.mobile.error': '新手機驗證碼校驗錯誤',
  'setting.txPassword.error': '交易密碼錯誤',
  'setting.new.txPassword.error': '交易密碼不能與當前密碼一樣',
  'setting.password.error': '登錄密碼校驗錯誤',
  'setting.new.password.error': '登錄密碼不能與前三次修改記錄一樣',
  'setting.face.error': '人臉信息校驗錯誤',
  'setting.error039930': '未獲取到安全校驗配置',
  'setting.error039931': '郵箱驗證碼錯誤',
  'setting.error039932': '手機驗證碼錯誤',
  'setting.error039935': '校驗手機或者郵箱錯誤',
  'message.error.030061': '手機已被綁定，請修改手機後重新操作',
  'message.error.030060': '郵箱已被綁定，請修改郵箱後重新操作',
  'user.TransactionPasswordError': '交易密碼校驗失敗',
  'message.error.7020': '帳戶不存在',

  //個人中心
  'user.personalInformation': '個人信息',
  'user.userInfo.title': '賬戶',
  'user.name': '姓名',
  'user.certificateType': '證件類型',
  'user.mainlandID': '大陸身份證',
  'user.passport': '護照',
  'user.hongKongID': '香港身份證',
  'user.otherID': '其他證件',
  'user.idNumber': '證件號碼',
  'user.customerNo': '用戶號',
  'user.accountStatus': '開戶狀態',
  'user.hasNotOpenAccount': '未開戶',
  'user.accountApproving': '資料審核中',
  'user.hasOpen': '已開戶',
  'user.frozen': '已凍結',
  'user.rejectApprove': '審核駁回',
  'user.accountCancellation': '已註銷',
  'user.inactivated': '未激活',
  'user.unknownStatus': '未知狀態',

  //幫助中心
  'helpCenter.header': '歡迎來到幫助中心',
  'user.help.search': '搜索',
  'help.search.result1': '搜索到與「',
  'help.search.result2': '「相關結果共',
  'help.search.result3': '條',
  //搜索到與「${XXX}「相關結果共${5}條
  'user.help.desc': '如果下列回答不能幫助到您, 您可以聯系',
  'user.help.desc.onlineServer': '在線客服',
  'user.help.desc.last': ' ',
  //如果下列回答不能幫助到您, 您可以聯系在線客服
  'user.help.more': '更多',
  'help.relate.title': '相關問題',

  //通用設置
  'user.language': '語言',
  'user.english': '英文',
  'user.simplifiedChinese': '簡體中文',
  'user.upDownColor': '漲跌色',
  'user.upRedDownGreen': '紅漲綠跌',
  'user.upGreenDownRed': '綠漲紅跌',

  //安全設置
  'user.modifyLoginPassword': '修改登錄密碼',
  'user.change.trcPsw': '修改交易密碼',
  'user.email': '郵箱',
  'user.mobile': '手機號',
  'user.change.withdraw': '出金管理',
  'setting.go.to.bind': '去綁定',
  'user.ok': '確認',
  'user.verifyMobile': '驗證當前綁定手機',
  'user.form.mobileCodeHash.placeholder': '請輸入手機驗證碼',
  'user.getVerifyCode': '獲取驗證碼',
  'user.verifyEmail': '驗證當前綁定郵箱',
  'user.emailCodeHash.placeholder': '請輸入郵箱驗證碼',
  'user.transactionPassword': '交易密碼',
  'user.finishTransactionPsw': '請輸入交易密碼',
  'user.loginPsw.label': '登錄密碼',
  'user.loginPsw.placeholder': '請輸入登錄密碼',
  'user.new.bind.phone': '新綁定手機號',
  'user.new.bind.phone.placeholder': '請輸入新綁定手機號',
  'user.verifyCode': '驗證碼',
  'user.pleaseFinishVerifyCode': '請輸入驗證碼',
  'user.new.bind.email': '新綁定郵箱',
  'user.new.bind.email.placeholder': '請輸入新綁定郵箱',
  'user.current.loginPsw': '原登錄密碼',
  'user.current.loginPsw.placeholder': '請輸入原登錄密碼',
  'user.new.loginPsw': '設置新登錄密碼',
  'user.new.loginPsw.placeholder': '請輸入8-12位字母、數字組合密碼',
  'user.repeat.new.loginPsw': '重復輸入新登錄密碼',
  'user.new.trans.psw': '設置新交易密碼',
  'user.new.trans.psw.again': '請再次確認交易密碼',
  'user.new.txPsw': '請輸入6位數字作為新的交易密碼',
  'user.emailRuleError': '郵箱格式有誤',
  'user.new.trans.psw.conform': '確認交易密碼',
  'newSetting.mobile.tip1': '*請您註意，您正在操作修改手機號，修改',
  'newSetting.mobile.tip1.1': '小時後才可出金；',
  'newSetting.mobile.tip2': '*修改後將使用新綁定手機號登錄及找回密碼；',
  'newSetting.bindMobile.tip1': '*請您註意，您正在操作綁定手機號，綁定',
  'newSetting.bindMobile.tip1.1': '小時後才可出金；',
  'newSetting.email.tip1': '*請您註意，您正在操作修改郵箱，修改',
  'newSetting.email.tip1.1': '小時後才可出金；',
  'newSetting.email.tip2': '*修改後將使用新綁定郵箱登錄及找回密碼；',
  'newSetting.bindEmail.tip1': '*請您註意，您正在操作綁定郵箱，綁定',
  'newSetting.bindEmail.tip1.1': '小時後才可出金；',
  'newSetting.password.tip1': '*請您註意，您正在操作修改登錄密碼；',
  'newSetting.txPassword.tip1': '*請您註意，您正在操作修改交易密碼，修改',
  'newSetting.txPassword.tip1.1': '小時後才可出金；',
  'newSetting.txPassword.tip2': '*請牢記此密碼，涉及交易和資金等影響賬戶安全的操作，都需要校驗交易密碼；',
  'newSetting.tip1': "*如您收不到驗證碼或忘記信息，請",
  'newSetting.tip2': "聯系客服",
  'newSetting.tip3': "處理。",
  'user.withdraw.management': '出金管理',
  'user.withdraw.address.auth': '出金地址認證',
  'asset.chainType4': 'TRC20(TRON,波場)',
  'asset.chainType1': 'ERC20(ETH,以太坊)',
  'asset.chainType2': 'OMNI(BTC,比特幣)',
  'withdraw.address.remark': '備註：',
  'withdraw.address.modify': '修改',
  'withdraw.address.unBind': '解綁',
  'withdraw.bind.address': '+綁定出金地址',
  'confirm.unBind.tip1': '解綁將從列表移除，是否解綁?',
  'bindAddress.button2': '立即認證',
  'asset.currency': '幣種',
  'user.bindAddress.chainType': '鏈名稱',
  'bindAddress.address.label': '出金地址',
  'bindAddress.address.placeholder': '請輸入出金地址',
  'bindAddress.address.error': '地址格式不正確',
  'bindAddress.remark': '備註  (選填)',
  'bindAddress.remark.placeholder': '備註選填',
  'bindAddress.password': '交易密碼',
  'user.form.mobileCodeHash': '手機驗證碼',
  'user.emailCodeHash': '郵箱驗證碼',
  'withdraww.bindAddess.tip1': '請您註意，您正在操作出金地址實名認證，認證',
  'withdraww.bindAddess.tip1.1': '小時後才可出金；',
  'user.hasModifyLoginPsw': '登錄密碼已修改',
  'user.hasModifyTransactionPsw': '交易密碼已修改',
  'user.hasModifyEmail': '郵箱已修改',
  'user.hasBindEmail': '郵箱已綁定',
  'user.hasBindMobile': '手機已綁定',
  'user.hasModifyMobile': '手機號已修改',
  'user.back': '返回',
  'user.modifyMobile': '修改手機',
  'user.modifyEmail': '修改郵箱',
  'user.bandEmail': '綁定郵箱',
  'user.bind.phone': '綁定手機號',
  'user.bind.address.title': '綁定出金地址',
  'user.bind.address.success': '出金地址已綁定',

  //聯系我們
  'user.contact.title': '添加客服微信，享受專屬服務',
  'user.contact.save': '保存圖片',
  'user.contact1': '微信客服1:',
  'user.contact2': '微信客服2:',
  'user.contact.email': '客服郵箱:',
  'user.contact.mobile': '客服電話:',
  'user.contactUsTips': '客服辦公時間工作日08:30-18:30，非工作時間請留言',

  //登陸註冊
  'user.getVerifyCodeFirst': '請先獲取驗證碼',
  'user.login': '登錄',
  'user.pleaseFinishPhoneNumber': '請輸入手機號',
  'user.pleaseFinishEmail': '請輸入郵箱',
  'user.forgetPassword': '忘記密碼',
  'user.password': '密碼',
  'user.password.placeholder': '請輸入密碼',
  'user.no.account.tip1': '沒有賬號請',
  'user.no.account.tip2': '註冊',
  'user.form.login.email': '郵箱登錄',
  'user.form.login.mobile': '手機登錄',
  'login.tip1': '註冊或登錄即代表已閱讀並同意',
  'login.tip2': '服務協議',
  'login.tip3': '和',
  'login.tip4': '隱私政策',
  'user.sign.up': '註冊',
  'user.nextStep': '下一步',
  'user.form.register.mobile': '手機註冊',
  'user.form.register.email': '郵箱註冊',
  'user.has.account.tip1': '已有賬號請',
  'user.has.account.tip2': '登錄',
  'message.send.code.success': '發送成功',
  'login.password.format.placeholder': '8-12位字母、數字組合密碼',
  'user.new.loginPsw.tip1': '8-12位字符',
  'user.new.loginPsw.tip2': '包含字母',
  'user.new.loginPsw.tip3': '包含數字',

  'form.search.address': '搜索國家/區號',
  'form.search.title': '國家/區號',
  'form.search.input': '搜索',
  'user.cancel': '取消',
  'user.login.authentication': '登錄驗證',
  'asset.beginTime': '開始時間',
  'asset.endTime': '結束時間',
  'asset.finance.page.noData': '暫無數據',

  'user.emailFind': '郵箱找回',
  'user.mobileFind': '手機找回',
  'forget.verifyEmail': '驗證郵箱',
  'forget.verifyMobile': '驗證手機',
  'forget.transactionPassword': '交易密碼',
  'forget.new.password': '新登錄密碼',
  'forget.confirm.password': '確認新密碼',

  'face.liveFace': '人臉識別',
  'face.click.camera': '點擊相機圖標，進行人臉識別',
  'face.check.success': '人臉識別成功',
  'face.check.fail': '人臉識別失敗',
  'face.action0': '眨眼',
  'face.action4': '擡頭',
  'face.action5': '低頭',
  'face.action7': '左右轉頭',
  'face.errer.tips': '活體未通過,已刷新動作，請重新錄製視頻',
  'face.ation.title': '實名認證',
  'face.ation.second.title': '請按下方要求完成視頻錄製',
  'face.first.ation': '動作一',
  'face.second.ation': '動作二',
  'face.ation.refresh': '刷新動作',
  'face.ation.tip.title': '溫馨提示：',
  'face.ation.tip1': '保持環境安靜，光線充足',
  'face.ation.tip2': '面部清晰完整',
  'face.ation.tip3': '按要求順序做標準動作',
  'face.ation.tip4': '拍攝3-5秒的視頻',
  'face.ation.btn': '開始錄製',
  'face.ation.btn.end': '結束錄製',
  'face.ation.btn.restart': '重新錄製',
  'face.ation.btn.finish': '完成',

  'notification.title': '通知消息',
  'noMore.data': '暫無更多數據',

  //開戶
  'v3.menu.share.open.add.info': '信息補充',
  'form.account.address.title': '開戶證件所屬地區',
  'form.account.type': '開戶證件類型',
  'form.account.type1': '大陸身份證',
  'form.account.type2': '香港身份證',
  'trs.first.passport': '護照',
  'form.account.type9': '本地身份證',
  'account.open.has.idNumber': '該證件號已存在',
  'form.account.name.upload.click.front': '上傳人像面',
  'form.account.name.upload.click.back': '上傳國徽面',
  'form.account.phone.tip': '拍攝提示',
  'menu.name.zh.cn': '姓名(中文)',
  'menu.name.zh.placeholder': '請填寫真實姓名,示例：張三',
  'menu.name.zh.first': '姓(拼音)',
  'menu.name.zh.first.placeholder': '示例：ZHANG',
  'menu.name.zh.second': '名(拼音)',
  'menu.name.zh.second.placeholder': '示例：SAN',
  'form.asset.withdraw.placeholder.input': '請輸入',
  'user.country': '國籍',
  'user.tax.country': '報稅地區',
  'user.birthday': '出生日期',
  'user.birthday.placeholder': '請選擇出生日期',
  'user.date.choose': '請選擇日期',
  'user.experied.date': '有效期截止',
  'user.experied.placeholder': '請選擇證件有效期',
  'user.experied.long.term': '長期有效',
  'form.user.safe.name.prefix.card.number': '證件號碼',
  'form.user.safe.name.placeholder.input.id': '請輸入證件號碼',
  'account.real.name.explain.first': '1、根據監管要求，投資前您需要完成開戶流程，填寫相關資料評估是否符合投資者要求。',
  'account.real.name.explain.two': '2、投資證券或金融產品存在潛在的虧損可能，投資者在進行投資前需考慮自身的投資目標及風險承受能力。',
  'face.finish.tip': '請先完成人臉認證',
  'v3.menu.share.open.title': 'WBroker開戶',
  'form.account.openMarket.title': '將為您開通的市場類型',
  'form.stock.hk': '港股',
  'form.stock.us': '美股',
  'form.stock.zht': '中華通',
  'form.account.risk': '風險披露',
  'form.account.risk.standar': '持牌代表：',
  'asset.account.open.audio.txt1': '您好，我是吳夢瑤，是WBroker的持牌代表，現在我簡單為您說明一下風險披露中的幾個要點：',
  'asset.account.open.audio.txt2': '1. 投資者因應自身的投資經驗，投資目的，經濟收支與相關狀況審慎選擇與投資風險偏好、與投資需求相應的投資產品或服務。買賣證券具有風險，證券價格可升可跌，有時可能會非常波動，甚至變成毫無價值。',
  'asset.account.open.audio.txt3': '2. 買賣衍生工具涉及高風險，並非每個投資者都適合。投資者需註意，一般而言，衍生產品的流通量較低，價格的波動比較大，也會受相關資產的價格或其公司行動或其他因素（如時間值）的影響而調整，提早解除相關衍生產品合約會比較困難和成本較高。若幹衍生產品會有固定的有效日期，到期後可能會變得沒有價值，也有被強製收回的風險。',
  'asset.account.open.audio.txt4': '3. 投資者無論是否美國公民或永久居民，只要以個人名義持有這些投資產品，均須繳付稅項。所有持有任何形式美國證券的人士均須就所得紅利支付預扣稅。投資者應留意海外投資涉及的稅務問題，並視乎情況尋求專業稅務意見。由於美股最低交易單位為 1股，投資者須留意交易傭金可能比交易金額為高。當指令執行後，投資必須繳付相關傭金及收費，傭金及收費的更新通知會不時透過本公司網頁或其他途徑發布。美股交易受美國證監會嚴格監管,並不在香港證監會的監管之內。',
  'asset.account.open.audio.txt5': ' 4. 作為客戶您需要自行承擔電子交易中可能產生的相關風險。 風險說明到此為止，請完成剩下的開戶流程，如果您有任何問題，請隨時聯系我們！謝謝！',
  'user.forth.tip1': '當您點擊',
  'user.forth.tip2': '「已閱讀」',
  'user.forth.tip3': '按鈕，表示您已閱讀並了解上述風險',
  //當您點擊${「已閱讀」}按鈕，表示您已閱讀並了解上述風險
  'user.forth.btn': '已閱讀',
  'trs.tenth.tip2': '請先完成簽署協議',
  'open.account.file.title': '簽署協議',
  'open.account.file.desc': '本人已詳細閱讀並同意簽署以下所有開戶文件',
  'open.account.file.title2': '個人聲明',
  'account.open.agrement.check.hkLetter.file': '《香港投資者識別碼製度-個人客戶同意函》',
  'account.open.agrement.check.customer.file': '《客戶協議書》',
  'account.open.agrement.check.risk': '《風險披露》',
  'account.open.agrement.check.no.usa': '《W-8Ben非美國人免稅表格》',
  'account.open.agrement.check.commitment': '《投資者承諾書》',
  'account.open.agrement.check1': '本人是該證券賬戶的最終且唯一受益人',
  'account.open.agrement.check2': '本人與本證券公司的董事和雇員沒有任何關系',
  'account.open.agrement.check3': '本人不是任何交易所，證券公司，或其他金融機構的持牌人，雇員，董事，高管',
  'account.open.agrement.check4': '本人沒有擔任任何重要公職，例如政府機關，軍隊，國有機構的重要崗位',
  'account.open.agrement.check5': '本人不是美國永久居民(綠卡持有者)',
  'account.open.sign.alert': '請完成手寫簽名',
  'account.open.sign.title': '手寫簽名',
  'account.open.sign.desc': '請確保您的手寫簽名與開戶本人姓名保持一致。',
  'account.open.sign.reset': '重寫',
  'account.open.setPsw.title': '設置初始交易密碼',
  'account.open.setPsw.title.confirm': '請再次確認交易密碼',
  'account.open.setPsw.tip': '請輸入6位數字',
  'account.open.setPsw.error': '密碼不一致，請重新輸入',
  'account.open.setPsw.bottom.tip': '*請牢記次密碼，涉及交易和資金等影響賬戶安全的操作，都需要校驗交易密碼',
  'stock.approving': '開戶審核中',
  'account.open.end.notice1': '您的申請資料已提交審核，預計一小時內完成審核並開戶',
  'form.asset.withdraw.placeholder.select': '請選擇',
  'form.account.house.has': '擁有',
  'form.account.house.use': '租用',
  'form.account.house.with': '與親戚同住',
  'form.account.stepGrray1': '0年',
  'form.account.stepGrray2': '1年-3年',
  'form.account.stepGrray3': '3年-10年',
  'form.account.stepGrray4': '>10年',
  'form.account.stepGrrayChildren1': '股票、債券及其他證券',
  'form.account.stepGrrayChildren2': '杠桿外匯',
  'form.account.stepGrrayChildren3': '貴重金屬',
  'form.account.stepGrrayChildren4': '期貨/期權',
  'form.account.stepHrray1': '了解',
  'form.account.stepHrray2': '不了解',
  'form.account.stepHrrayChildren1': '擁有曾買賣衍生產品的經驗',
  'form.account.stepHrrayChildren2': '曾接受有關衍生產品的培訓或修讀相關課程',
  'form.account.stepHrrayChildren3': '擁有涉及衍生工具的工作經驗',
  'form.account.choose.houseStatus': '請選擇住房情況',
  'form.account.houseStatus.value': '請輸入估值',
  'form.account.houseStatus.number': '房屋估值只能輸入數字',
  'form.account.work.status': '請選擇就業狀態',
  'form.account.input.work.status': '請輸入就業情況',
  'form.account.choose.edu': '請選擇教育程度',
  'form.account.choose.asset': '請選擇總資產',
  'form.account.choose.income': '請選擇年收入',
  'form.account.choose.target': '請選擇投資目標',
  'form.account.choose.experience': '請選擇投資經驗',
  'form.account.choose.experienceType': '請選擇投資類型',
  'form.account.choose.derivativesKnowledge': '請選擇衍生品知識',
  'form.account.choose.hasKnowledge': '請選擇衍生工具知識',
  'form.account.choose.riskTolerance': '風險承受能力項不符合監管要求，您將不能開戶',
  'form.account.houseSituation': '住房情況',
  'form.account.valuation': '估值（扣除按揭）',
  'form.account.valuation.placeholder': '請填寫估值',
  'form.account.work.label1': '雇主姓名',
  'form.account.work.label1.placeholder': '請輸入雇主姓名',
  'form.account.work.label2': '職業/職務',
  'form.account.work.label2.placeholder': '請輸入職業/職務',
  'form.account.work.label3': '任職年期',
  'form.account.work.label3.placeholder': '請輸入任職年期',
  'form.account.work.label4': '職位',
  'form.account.work.label4.placeholder': '請輸入職位',
  'form.account.work.label5': '業務性質',
  'form.account.work.label5.placeholder': '請輸入業務性質',
  'form.account.investmentExperience': '投資類型',
  'form.account.derivativesKnowledge': '衍生品知識',
  'form.account.derivativesKnowledge0': '如何了解有關衍生工具知識',
  'form.account.name.prefix.address': '居住地址',
  'form.account.name.placeholder.input.address': '請輸入居住地址',
  'account.open.form.work.status': '就業狀態',
  'account.open.form.work.hire': '受雇',
  'account.open.form.work.hire.self': '自雇',
  'account.open.form.work.other': '其它',
  'account.open.education.status': '教育程度',
  'account.open.education.status.primary': '小學或以下',
  'account.open.education.status.middle': '中學',
  'account.open.education.status.college': '大專',
  'account.open.education.status.undergraduate': '本科或以上',
  'account.open.asset.status': '總資產',
  'account.open.asset.status30': '< 30萬',
  'account.open.asset.status100': '30萬-100萬',
  'account.open.asset.status500': '100萬-500萬',
  'account.open.asset.status.more': '>500萬',
  'account.open.asset.year.status': '年收入',
  'account.open.asset.year.status10': '< 10萬',
  'account.open.asset.year.status30': '10萬-30萬',
  'account.open.asset.year.status500': '30萬-500萬',
  'account.open.asset.year.status.more': '>500萬',
  'account.open.invest.target': '投資目標',
  'account.open.invest.target.no.lose': '保本',
  'account.open.invest.target.share': '分紅',
  'account.open.invest.target.all': '投資/投機',
  'account.open.invest.experience': '投資經驗',
  'account.open.invest.experience.no': '沒有',
  'account.open.invest.experience.soso': '一般',
  'account.open.invest.experience.much': '豐富',
  'account.open.affordability.status': '風險承受能力',
  'account.open.taffordability.status.no': '不能容忍虧損',
  'account.open.taffordability.status.low': '低(虧5-10%)',
  'account.open.taffordability.status.mid': '中(虧10-20%)',
  'account.open.taffordability.status.high': '高(虧20%以上)',
  'account.open.quit.message': '確定退出開戶流程嗎？',
}
